import script from "./DatasetSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetSummary.vue?vue&type=script&setup=true&lang=ts"

import "./DatasetSummary.vue?vue&type=style&index=0&id=5fe85e8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fe85e8c"]])

export default __exports__